module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter"
  }, [_c('FilterSelectBlock', {
    staticClass: "filter__block",
    attrs: {
      "monthValue": _vm.monthValue,
      "monthYear": _vm.monthYear
    },
    on: {
      "monthChange": _vm.monthChange,
      "yearChange": _vm.yearChange
    }
  }), _c('FilterBottonsBlock', {
    on: {
      "selectedType": _vm.fillteredOut
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01e07532","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendarfilter/CalendarFilter.vue
// module id = 1a2fff4ed7d328c8f1b2
// module chunks = 7